
import { ActionType } from '@editor/src/js/constants/common-action-type';

const TextEditItemsType = {
    EditFont: [
        ActionType.BOLD,
        ActionType.ITALIC,
        ActionType.UNDERLINE,
        ActionType.DELETELINE,
    ],
    EditAlign: [
        ActionType.HORIZONTAL_ALIGN,
        ActionType.VERTICAL_ALIGN,
    ],
    EditItemNumber: [
        ActionType.ITEMNUMBER,
        ActionType.DIGITNUMBER,
    ],
    EditFontSize: [
        ActionType.FONTSIZE,
    ],
};

export interface IEditItem {
    id: string;
    value: string;
    defaultValue?: string;
    data?: Array<object|string>;
    selected?: boolean;
}
export interface ITextEditItemsData {
    editFontItemsData: Array<object>;
    editAlignItemsData: Array<object>;
    editItemNumberItemsData: Array<object>;
    editFontSize: Array<{
        id: string;
        data: Array<IEditItem>;
        value: string;
        disabled?: boolean;
    }>;
    editFontColor: {
        id?: string;
        data?: Array<IEditItem>;
        value?: string;
        disabled?: boolean;
    };
    editFillColor: {
        id?: string;
        data?: Array<IEditItem>;
        value?: {
            color?: string;
        };
        disabled?: boolean;
    };
    editBorderColor: {
        id?: string;
        data?: Array<IEditItem>;
        value?: {
            color?: string;
        };
        disabled?: boolean;
    };
}
export default class TextEditDataProcesser {
    public static getTextEditItemsData(itemDatas): ITextEditItemsData {
        if (!itemDatas?.length) {
            return {
                editFontItemsData: [],
                editAlignItemsData: [],
                editItemNumberItemsData: [],
                editFontSize: [],
                editFontColor: {},
                editFillColor: {},
                editBorderColor: {},
            };
        }
        const textEdutItemsData = {
            editFontItemsData: itemDatas.filter(itemData => TextEditItemsType.EditFont.includes(itemData.id)),
            editAlignItemsData: itemDatas.filter(itemData => TextEditItemsType.EditAlign.includes(itemData.id)),
            editItemNumberItemsData:
                itemDatas.filter(itemData => TextEditItemsType.EditItemNumber.includes(itemData.id)),
            editFontSize: itemDatas.filter(itemData => TextEditItemsType.EditFontSize.includes(itemData.id)),
            editFontColor: itemDatas.find(itemData => itemData.id === ActionType.FORECOLOR),
            editFillColor: itemDatas.find(itemData => itemData.id === ActionType.FILLCOLOR),
            editBorderColor: itemDatas.find(itemData => itemData.id === ActionType.BORDERCOLOR),
        };
        return textEdutItemsData;
    }
}
